<template>
  <div class="d-flex">
    <span
      v-for="(entity, idx) in avatars"
      :style="`margin-left: ${idx > 0 ? overlap : 0};`"
      :key="entity.id"
      :class="entity.numberActions > 0 && showBadge ? 'avatarWithBadge' : 'pr-1'"
    >
      <AvatarComponent
        :color="colorForEntity(entity)"
        :text="initialsForName(entity.displayName)"
        :tooltip="entity.displayName"
        :size="28"
        :badge-text="showBadge ? entity.numberActions : ''"
        :square="isGroupType(entity.entityType)"
      />
    </span>
    <span
      style="margin-left: -14px;"
      v-if="showNumberOfExtraAvatars && extraAvatars > 0"
    >
      <AvatarComponent
        color="grey"
        :text="`+ ${extraAvatars}`"
        :size="28"
      />
    </span>
  </div>
</template>
<script>
import get from 'lodash/get';
import AvatarComponent from '../avatar/AvatarComponent';
import {
  ACL_TYPE_GROUP,
  ACL_TYPE_USER,
} from '../../constants/backendConstants';
import { getColorForId } from '../../tools/UsersColors';

export default {
  name: 'AnalysisAvatars',
  components: { AvatarComponent },
  props: {
    analysis: {
      type: Object,
      required: true,
    },
    userAnalyses: {
      type: Array,
      default: () => [],
    },
    overlap: {
      type: String,
      default: '0px',
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    maxAvatars: {
      type: Number,
      default: 9,
    },
    showNumberOfExtraAvatars: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      avatars: [],
      extraAvatars: 0,
    };
  },
  methods: {
    colorForEntity(entity) {
      if (entity.id) return getColorForId(entity.id);

      return getColorForId(entity.entityId);
    },
    initialsForName(name) {
      return name ? name.split(' ').map(n => n.substring(0, 1)).join('') : '';
    },
    countUserActions(userAnalysis) {
      const visibleSigElems = get(userAnalysis, 'evaluation.significantElements', [])
        .filter(elem => !elem.archived);
      const visibleComments = get(userAnalysis, 'reflection.comments', [])
        .filter(elem => !elem.archived);

      return visibleSigElems.length + visibleComments.length;
    },
    userHasAnalysis(userId) {
      return this.userAnalyses.findIndex((uAnalysis) => uAnalysis.id === userId) >= 0;
    },
    isGroupType(type) {
      return type === ACL_TYPE_GROUP;
    },
    calculateAvatars() {
      const usersWithAnalyses = this.userAnalyses.map(userAnalysis => ({
        id: userAnalysis.id,
        displayName: userAnalysis.displayName,
        // TODO handle very large numbers in a way that won't break the ui look
        numberActions: this.showBadge ? this.countUserActions(userAnalysis) : 0,
      }));

      const groups = [];
      const users = [];

      this.analysis.acl.forEach(acl => {
        switch (acl.entityType) {
          case ACL_TYPE_GROUP:
            groups.push(acl);
            return;
          case ACL_TYPE_USER:
            if (!this.userHasAnalysis(acl.entityId)) {
              users.push(acl);
            }
            return;
          default:
            console.error('Unknown entityType for acl', acl);
        }
      });
      const avatars = groups.concat(usersWithAnalyses).concat(users);

      if (avatars.length > this.maxAvatars - 1) {
        this.extraAvatars = avatars.length - this.maxAvatars;
      } else {
        this.extraAvatars = 0;
      }

      this.avatars = avatars.slice(0, this.maxAvatars);
    },
  },
  watch: {
    analysis() {
      this.calculateAvatars();
    },
    userAnalyses() {
      this.calculateAvatars();
    },
  },
  mounted() {
    this.calculateAvatars();
  },
};
</script>
<style scoped>
.avatarWithBadge {
  padding-right: 6px;
}
</style>
